
<div>
    <div class="card-container">
        @if(this.defaultBank) {
            <mat-card class="status-card" [routerLink]="navigate(this.defaultBank)">
                <div class="card-heading">Days Cash</div>
                <div class="content">
                    {{daysCash}}
                </div>
                <div class="footer">
                    Number of budgets days cash available
                </div>
            </mat-card>  
        }
        @for( bank of accounts; track $index) {
            <mat-card class="status-card" [routerLink]="navigate(bank)">
                @if(!bank.gocId) {
                    <mat-icon color="warn" matTooltip="Account not linked - link this account to reduce manual work">link_off</mat-icon>
                }                
                <div class="card-heading">
                    {{ bank.name }}
                </div>
                <div class="content currency">
                    {{ nrHelper.toFormattedCurrency(bank.lastBalance || bank.lastRecBalance, 0)}}
                </div>
                <div class="footer">
                    @if (bank.gocLastPull && dateHelper.secondsFromToday(bank.gocLastPull) < (0 - (48*60*60))) {
                        <span class="redBackground" matTooltip="Last bank connection was {{dateHelper.localDateTime(bank.gocLastPull)}}">
                            Connection Broken
                        </span>
                    } @else if (bank.lastRecDate) {
                        @let daysAgo = dateHelper.daysFromToday(bank.lastRecDate);
                        @if (daysAgo < -90) {
                            <span class="redBackground" matTooltip=" Last reconciled {{ dateHelper.localDate(bank.lastRecDate)}}">Needs Reconciliation</span>
                        } @else if (daysAgo <= -60) {
                            <span class="greenText">Last Reconciled {{ dateHelper.localDate(bank.lastRecDate)}}</span>
                        } @else if (daysAgo <= -30) {
                            <span class="amberText">Last Reconciled {{ dateHelper.localDate(bank.lastRecDate)}}</span>
                        } @else {
                            <span class="greenText">Reconciled {{ dateHelper.localDate(bank.lastRecDate)}}</span>
                        }
                    } @else {
                        <span class="redBackground">NOT RECONCILED</span>
                    }
                </div>
            </mat-card>
        }
    </div>
</div>